module.exports = __webpack_public_path__ + "static/media/createUserKan.81ebe02e.jpg";